export function parseBase64ToImage (base64String: string): string {
  if (base64String)
    return `data:image/png;base64, ${ base64String }`;


  return "";
}
